"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EnviPodpisPage;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const SigningApi_1 = require("./SigningApi");
function VersionLine({ state }) {
    if (state.status === "loading") {
        return (react_1.default.createElement(react_bootstrap_1.Card.Text, { className: "text-muted mb-0" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-2", "aria-label": "Sprawdzanie wersji" }),
            "Sprawdzam wersj\u0119..."));
    }
    if (state.status === "error") {
        return react_1.default.createElement(react_bootstrap_1.Card.Text, { className: "text-muted mb-0" }, "Nie uda\u0142o si\u0119 sprawdzi\u0107 wersji programu.");
    }
    if (!state.info.available)
        return null;
    if (!state.info.version)
        return null;
    return react_1.default.createElement(react_bootstrap_1.Card.Text, { className: "text-muted mb-0" },
        "Wersja dost\u0119pna w PS: ",
        state.info.version);
}
function EnviPodpisPage() {
    const [state, setState] = (0, react_1.useState)({ status: "loading" });
    (0, react_1.useEffect)(() => {
        let active = true;
        SigningApi_1.SigningApi.programInfo().then(info => { if (active)
            setState({ status: "ready", info }); }, () => { if (active)
            setState({ status: "error" }); });
        return () => { active = false; };
    }, []);
    const unavailable = state.status === "ready" && !state.info.available;
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4", style: { maxWidth: 760 } },
        react_1.default.createElement("h4", null, "ENVI Podpis"),
        react_1.default.createElement("p", { className: "text-muted" },
            "ENVI Podpis to program na Tw\u00F3j komputer. Podpisuje pisma z PS podpisem kwalifikowanym z karty, wi\u0119c potrzebny jest czytnik kart i Twoja karta kwalifikowana. PS otwiera program sam po klikni\u0119ciu ikony ",
            react_1.default.createElement("em", null, "PDF z podpisem kwalifikowanym"),
            " przy pi\u015Bmie (nazwa pokazuje si\u0119 po najechaniu mysz\u0105) - nie uruchamiasz go r\u0119cznie."),
        react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-4" },
            react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "d-flex flex-wrap align-items-center justify-content-between gap-3" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_bootstrap_1.Card.Title, { className: "mb-1" }, "Program ENVI Podpis"),
                    react_1.default.createElement(VersionLine, { state: state }),
                    unavailable && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "mt-2 mb-0" }, "Program nie jest teraz dost\u0119pny do pobrania. Zg\u0142o\u015B to administratorowi."))),
                !unavailable && (react_1.default.createElement(react_bootstrap_1.Button, { href: SigningApi_1.SigningApi.programDownloadUrl(), variant: "primary", size: "lg" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDownload, className: "me-2" }),
                    "Pobierz ENVI Podpis")))),
        react_1.default.createElement("h5", null, "Instalacja i aktualizacja"),
        react_1.default.createElement(react_bootstrap_1.ListGroup, { numbered: true, className: "mb-4" },
            react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null, "Pobierz plik i uruchom go."),
            react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null, "Nowsza wersja instaluje si\u0119 na starsz\u0105 - nic nie trzeba odinstalowywa\u0107."),
            react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null, "PS nie wie, jak\u0105 wersj\u0119 masz na komputerze. Je\u015Bli PS b\u0119dzie wymaga\u0142 nowszej, program sam to powie przy podpisie - wtedy wr\u00F3\u0107 na t\u0119 stron\u0119 i pobierz go jeszcze raz."))));
}
